import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function isAdmin() {
  try {
    const roles = JSON.parse(localStorage.getItem('roles') || '[]');
    return Array.isArray(roles) && roles.includes('administrator');
  } catch (err) {
    return false;
  }
}

function AdminRoute({ component: Component, ...rest }) {
  const isAuthenticated = !!localStorage.getItem('auth');

  return (
    <Route
      {...rest}
      render={props =>
        !isAuthenticated
          ? <Redirect to="/user/login" />
          : isAdmin()
            ? <Component {...props} />
            : <Redirect to="/" />
      }
    />
  );
}

export default AdminRoute
